// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CircleLoader-module-svgContainer-1NNne{transform-origin:center;animation:CircleLoader-module-rotate-2fkAM 2s linear infinite}.CircleLoader-module-circleGrey-3pF86{fill:none;stroke:var(--des-color-fill-control-level6);stroke-width:4}.CircleLoader-module-circleBlack-kXRS7{fill:none;stroke:var(--des-color-fill-control-level2);stroke-width:4;stroke-dasharray:1,200;stroke-dashoffset:0;stroke-linecap:round;animation:CircleLoader-module-dash-3bBSm 1.5s ease-in-out infinite}@keyframes CircleLoader-module-rotate-2fkAM{100%{transform:rotate(360deg)}}@keyframes CircleLoader-module-dash-3bBSm{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:90,200;stroke-dashoffset:-35px}100%{stroke-dashoffset:-125px}}", ""]);
// Exports
exports.locals = {
	"svgContainer": "CircleLoader-module-svgContainer-1NNne",
	"rotate": "CircleLoader-module-rotate-2fkAM",
	"circleGrey": "CircleLoader-module-circleGrey-3pF86",
	"circleBlack": "CircleLoader-module-circleBlack-kXRS7",
	"dash": "CircleLoader-module-dash-3bBSm"
};
module.exports = exports;
